var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', {
    staticClass: "table-item",
    "class": {
      "new": _vm.isNew
    },
    on: {
      "click": function click($event) {
        return _vm.goToDetail(_vm.item.id);
      }
    }
  }, [_c('td', [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: _vm.tt(_vm.tooltipReason),
      expression: "tt(tooltipReason)",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "checkbox",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('input', {
    attrs: {
      "disabled": !_vm.isCanPay,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": function change($event) {
        return _vm.checkedId(_vm.item.id);
      }
    }
  })])]), _c('td', {
    staticStyle: {
      "width": "80px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "80px",
      "max-width": "120px"
    }
  }, [_c('span', {
    "class": ['expenditure', 'status', _vm.item.paymentStatus, _vm.isCancelOrReturn]
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.paymentStatus)))])])]), _c('td', [_c('div', [_c('span', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.tt(_vm.orderStatus)))])]), _vm.orderStatusSub ? _c('p', {
    staticStyle: {
      "color": "#ff3b31",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.tt(_vm.orderStatusSub)))]) : _vm._e()])])]), _c('td', [_c('div', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.showOrderDetail
    }
  }, [_vm._v(_vm._s(_vm.item.orderNo))])])]), _c('td', [_c('div', {
    staticClass: "info-wrap",
    staticStyle: {
      "min-width": "350px",
      "max-width": "450px"
    }
  }, [_c('p', {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.formatText(_vm.item.product.name)))]), _vm.item.product.brand || _vm.item.product.subname ? _c('p', {
    staticClass: "info-sub"
  }, [_vm._v(" " + _vm._s(_vm.item.product.brand ? _vm.item.product.brand.name : '') + " | " + _vm._s(_vm.item.product.subname ? _vm.item.product.subname : '') + " ")]) : _vm._e()])]), _vm.isView('quantity') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.item.quantity))])])]) : _vm._e(), _vm.isView('payerName') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatText(_vm.item.payerName)))])])]) : _vm._e(), _vm.isView('budgetName') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.item.budget ? _vm.item.budget.name : '-'))])])]) : _vm._e(), _vm.isView('price') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.tt('${1}원', _vm.item.orderItemPriceWithVat.toLocaleString())))])])]) : _vm._e(), _vm.isView('draftNo') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.item.draft.subject ? _vm.item.draft.no : '-'))])])]) : _vm._e(), _vm.isView('paymentDatetime') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatDatetimeFromISO(_vm.item.paymentDatetime)))])])]) : _vm._e(), _vm.isView('draftName') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatText(_vm.item.draft.subject)))])])]) : _vm._e(), _vm.isView('group') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.item.group ? _vm.item.group.name : '-'))])])]) : _vm._e(), _vm.isView('orderer') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.item.orderer.name))])])]) : _vm._e(), _vm.isView('createDatetime') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatDatetimeFromISO(_vm.item.createDatetime)))])])]) : _vm._e(), _vm.isView('concluder') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(!_vm.item.draft.isDirect ? _vm.item.concluderName : '-'))])])]) : _vm._e(), _vm.isView('concludeDatetime') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(!_vm.item.draft.isDirect ? _vm.formatDatetimeFromISO(_vm.item.concludeDatetime) : '-'))])])]) : _vm._e(), _vm.isView('paymentNo') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatText(_vm.item.paymentNo)))])])]) : _vm._e(), _vm.isView('paymentCreateDatetime') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatDatetimeFromISO(_vm.item.paymentCreateDatetime)))])])]) : _vm._e(), _vm.isView('businessRegistrationName') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatText(_vm.item.businessRegistrationName)))])])]) : _vm._e(), _vm.isView('paymentMethod') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.tt(_vm.paymentMethod)))])])]) : _vm._e(), _vm.isView('platform') ? _c('td', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.tt(_vm.item.orderPath)))])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }